import useTaskSearchFilters from '../useTaskSearchFilters/useTaskSearchFilters';
import { useFirmId } from '../../../hooks/useClientWorkflow/useClientWorkflow';
import useSearchTasks from './useSearchTasks';
import {
  useContactId,
  useEntityId,
} from '../useEntityContext/useEntityContext';
export default function useTasksFromUrl(
  {
    disableAutoFetch,
    isClientContext,
  }: { disableAutoFetch?: boolean; isClientContext?: boolean } = {
    disableAutoFetch: false,
    isClientContext: false,
  }
) {
  const { filters } = useTaskSearchFilters();
  const { firmId } = useFirmId();
  const entityId = useEntityId();
  const contactId = useContactId();

  return useSearchTasks({
    firmId: firmId,
    ...filters,
    entityId: entityId === firmId ? undefined : entityId,
    contactId: contactId,
    disableAutoFetch,
    skipCondition: isClientContext && entityId === firmId,
  });
}
